import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PageHeaderComponent {
  @Input() title: string
  @Input() icon: string
  @Input() appendNoTranslationTitlePart: string
  @Input() fullWidthPageTitle: boolean
  @Input() isOrderLayout: boolean
  @Input() isFlexWrap: boolean
  @Input() isHeadingNoWrap: boolean
  @Input() isStockOperation: boolean
  @Input() isOnProductWithAllBtns: boolean

  constructor() {
    // console.log(this.title)
    // console.log(this.icon)
    // console.log(this.appendNoTranslationTitlePart)
    // console.log(this.fullWidthPageTitle)
    // console.log(this.isOrderLayout)
    // console.log(this.isFlexWrap)
    // console.log(this.isHeadingNoWrap)
    // console.log(this.isStockOperation)
    // console.log(this.isOnProductWithAllBtns)
  }
}
